import { Iterable } from "immutable";
import { applyMiddleware, compose, createStore } from "redux";
// eslint-disable-next-line
import { createLogger } from "redux-logger";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./root-reducer";
import rootSaga from "./root-saga";

const sagaMiddleware = createSagaMiddleware();

const loggerMiddleware = createLogger({
  stateTransformer: state => {
    const newState = {};
    // eslint-disable-next-line
    for (let i of Object.keys(state)) {
      if (Iterable.isIterable(state[i])) {
        newState[i] = state[i].toJS();
      } else {
        newState[i] = state[i];
      }
    }
    return newState;
  }
});

let composeEnhancers = compose;
if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

// eslint-disable-next-line
export const store = createStore(
  rootReducer,
  composeEnhancers(
    process.env.NODE_ENV === "development"
      ? applyMiddleware(loggerMiddleware, sagaMiddleware)
      : applyMiddleware(sagaMiddleware)
  )
);

sagaMiddleware.run(rootSaga);
